/** @format */

/**
 * Base class for setting up a subject (observer pattern)
 */
export abstract class Subject<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    O extends (args: any) => void,
    S = Parameters<O>[0],
> {
    private observers: O[] = [];

    /**
     * Adds an observer to be called when the notify method is called
     *
     * @param observer A callback function
     */
    public attach(observer: O) {
        this.observers.push(observer);
    }

    /**
     * Removes an observer
     *
     * @param observer A callback function
     */
    public detach(observer: O) {
        this.observers = this.observers.filter((fn) => fn !== observer);
    }

    /**
     * Notifies the observers with new data
     *
     * @param data The data to pass to the observers
     */
    public notify(data: S) {
        this.observers.forEach((fn) => fn(data));
    }
}
